export default __webpack_public_path__ + "static/media/CommunityPlaceholder.f97952a4.svg";